@if (showCommentModal) {
  <div
    class="absolute inset-0 z-50 grid place-items-center bg-gray-500/30"
    (click)="closeCommentModal()"
  >
    <div
      class="absolute z-50 flex w-[25rem] flex-col gap-3 rounded-lg bg-white p-5 shadow-lg"
      (click)="$event.stopPropagation()"
    >
      <h1 class="text-lg font-semibold">Leave a Comment</h1>
      <form
        [formGroup]="commentForm"
        (ngSubmit)="addComment()"
        class="flex flex-col gap-1"
      >
        <input
          [class]="
            commentForm.touched && commentForm.invalid
              ? '!border !border-l-4 !border-l-red-600'
              : commentForm.touched && commentForm.valid
                ? '!border !border-l-4 !border-l-green-500'
                : ''
          "
          formControlName="comment"
          placeholder="Enter your comment here"
          type="text"
          id="comment"
          name="comment"
          autocomplete="off"
          [disabled]="isSubmitting"
        />
      </form>
      <!-- actions -->
      <div class="flex items-center justify-end gap-2">
        <p-button
          variant="text"
          severity="contrast"
          label="Cancel"
          (click)="closeCommentModal()"
        />
        <p-button
          [disabled]="commentForm.status === 'INVALID' || isSubmitting"
          (click)="addComment()"
          label="Comment"
        />
      </div>
      <!-- history -->
      <div class="relative max-h-[200px] space-y-1 overflow-y-auto pr-5">
        <!-- comment -->
        @for (comment of comments; track comment; let index = $index) {
          <ng-container
            [ngTemplateOutlet]="commentTemplate"
            [ngTemplateOutletContext]="{
              $implicit: comment,
              index: index,
            }"
          />
        }
      </div>
      <!-- close -->
      <p-button
        variant="text"
        severity="contrast"
        size="small"
        (click)="closeCommentModal()"
        class="absolute right-1 top-1"
      >
        <svg-icon src="/assets/icons/general/close.svg" />
      </p-button>
    </div>
  </div>
}

<ng-template #commentTemplate let-comment let-index="index">
  <div class="flex gap-3">
    <ag1-avatar
      class="w-10"
      [avatarUrl]="serverSideFileHelper.fullUrl(comment.user.avatarFile)"
      [label]="userHelper.getFullName(comment.user)"
    />

    <div class="space-y-1">
      <!-- comment owner -->
      <h1 class="text whitespace-nowrap font-semibold">
        @if (myUser.id === comment.userId) {
          You
        }
        @if (myUser.id !== comment.userId) {
          {{ userHelper.getFullName(comment.user) }}
        }
      </h1>

      <!-- comment content -->
      <p>
        {{ comment.commentText }}
      </p>

      <!-- comment details -->
      <div class="flex items-center justify-between gap-1">
        @if (myUser.id === comment.userId) {
          <p-button
            size="small"
            (click)="deleteComment(comment, index)"
            severity="danger"
            label="Delete"
            variant="text"
          />
        }
        <span class="ml-auto text-sm text-slate-500">{{
          comment.updatedAt | date: "dd MMM yyyy, hh:mm"
        }}</span>
      </div>
    </div>
  </div>
</ng-template>
